export const BASE_GROUP_LINKS = {
  LINK_404: `/404`,
  LINK_500: `/500`,
};
